<template>
    <div>
        <rkm-table
            :fields="fields.tables.evasoes"
            :filter="model.filter"
            :items="items"
            ref="RkmTable"
            hide-filters
        >
            <template v-slot:filters>
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidade"
                            disabled
                            label="Unidade"
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestrutura"
                            disabled
                            label="Local de atendimento"
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-input
                            label="Buscar"
                            placeholder="Digite para buscar"
                            v-model="model.filter"
                        />
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:cell(motivo)="row">
                <rkm-button
                    color="secondary"
                    small
                    v-rkm-popover.hover.left="{
                        title:'Motivo da evasão',
                        html:true,
                        content: row.item.motivoEvasao
                        }"
                >
                    <rkm-icon icon="comment-dots" />
                </rkm-button>
            </template>

            <template v-slot:cell(nome)="row">
                <rkm-button
                    color="secondary"
                    class="mr-2"
                    small
                    v-rkm-popover.hover.left="{
                        title:'Dados cadastrais',
                        html:true,
                        content: '<b>Prontuário</b>: ' + row.item.prontuario + '<br />'
                                + '<b>Data de nascimento</b>: ' + row.item.dataNascimento + '<br />'
                                + '<b>Nome da mãe</b>: ' + row.item.nomeMae + '<br />'
                        }"
                >
                    <rkm-icon icon="user" />
                </rkm-button>

                <span v-if="!row.item.sequencialDesconhecido">

                    {{ row.item.nome }}

                    <template v-if="row.item.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{row.item.nomeSocial}})</strong>
                    </template>
                </span>
                <span
                    v-else
                    class="text-primary"

                    v-rkm-popover.hover.top="{
                        title:'Características físicas',
                        container: 'body',
                        content: row.item.caracteristicasFisicas
                    }"
                >
                    {{row.item.nome}}
                </span>
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    @click="$refs.ModalCancelamentoEvasao.open(row.item)"
                    color="primary"
                    title="Cancelar evasão"
                    authorize="cancel-pronto-atendimento-cancelamento-evasao"
                    small
                >
                    <rkm-icon icon="file-upload" />
                </rkm-button>
            </template>

        </rkm-table>

        <ModalCancelamentoEvasao ref="ModalCancelamentoEvasao" @saved="saved" />
    </div>
</template>

<script>
// Components.
import ModalCancelamentoEvasao from '@/components/pronto-atendimento/cancelamento-evasao/components/Modal'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    components: { ModalCancelamentoEvasao },
    computed: {
        ...mapGetters({ lotacao: 'getLotacao' }),

        fields() {
            return {
                tables: {
                    evasoes: [
                        { key: 'data', label: 'Data', class: 'col-min text-center', sortable: true },
                        { key: 'hora', label: 'Horário', class: 'col-min text-center' },
                        { key: 'faaNumero', label: 'FAA', class: 'col-min text-center', sortable: true },
                        { key: 'nome', label: 'Paciente', class: 'col-min', sortable: true },
                        { key: 'setor', label: 'Último setor', class: 'col-min text-center', sortable: true },
                        { key: 'motivo', label: 'Motivo da evasão', class: 'col-min text-center' },
                        { key: 'actions', label: 'Ações', class: 'col-min text-center' },
                    ]
                }
            }
        },
        validations() {
            return {
                motivoCancelamentoEvacao: {
                    required: true,
                    max: 500,
                    min: 3,
                },
            }
        },
    },
    created() {
        this.repositories = {
            cancelamentoEvasao: this.getConectaSusRepository('prontoAtendimento.cancelamentoEvasao')
        }
        this.form.unidade =  [{
            id: this.lotacao.infraestrutura.unidade.id,
            nomeFantasia: this.lotacao.infraestrutura.unidade.nomeFantasia,
        }]
        this.form.infraestrutura = [{
            id: this.lotacao.infraestrutura.id,
            nome: this.lotacao.infraestrutura.nome,
        }]
        this.model.unidadeId = this.lotacao.infraestrutura.unidade.id
        this.model.infraestruturaId = this.lotacao.infraestrutura.id
    },
   data: () => ({
        form: {
            unidade: [],
            infraestrutura: [],
        },
        items: [],
        model: {
            filter: null,
            unidadeId: null,
            infraestruturaId: null,
        },
        enums: { preferenciaNome },
    }),
    methods: {
         ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()
            this.repositories.cancelamentoEvasao.datatable({infraestrutura_id: this.model.infraestruturaId})
                .then(response => {
                    this.items = response.data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        saved(faaId) {
            this.items.splice(this.items.findIndex(i => i.faaId === faaId), 1)
        }
    },
    mixins: [ error, repository, stringCase ],
    props: {
        id: { type: [Number, String] },
    },
    mounted() {
        this.load()
    },
}
</script>